<template>
    <button class="button">
        <slot/>
    </button>
</template>

<style scoped>
.button {
    background-color: #007BFF;
    border-radius: 50px;
    padding: 14px 0;

    font-size: 20px;
    font-family: "Segoe UI";
    font-weight: 600;
    color: white;

    border: none;

    cursor: pointer;

    width: 100%;
}

.button:hover {
    background: linear-gradient(88.06deg, #FF143F -15.18%, #C600DD 55.91%, #1B27FF 127.09%);
}

.button:disabled {
    opacity: 0.7;
}
</style>